import '@ids/style-checkbox';
import '@ids/style-label';
import '@ids/style-error-message';

type CheckboxProps = {
  isChecked: boolean;
  setIsChecked: (checked: boolean) => void;
  showCheckboxError: boolean;
  setShowCheckboxError: (show: boolean) => void;
  checkboxLabel: string;
  checkboxError: string;
};

const Checkbox = ({
  isChecked,
  setIsChecked,
  showCheckboxError,
  setShowCheckboxError,
  checkboxLabel,
  checkboxError,
}: CheckboxProps) => {
  return (
    <div>
      <form>
        <div className="if flex-column gap-24 my-8">
          <div className="if checkbox">
            <input
              className="if checkbox-input"
              type="checkbox"
              id="checkbox-with-label"
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
                if (e.target.checked) setShowCheckboxError(false);
              }}
            />
            <label className="if label small" htmlFor="checkbox-with-label">
              {checkboxLabel}
            </label>
          </div>
        </div>
      </form>
      {showCheckboxError && checkboxError && <span className="if error-message">{checkboxError}</span>}
    </div>
  );
};

export default Checkbox;
